import 'modern-normalize';
import './src/styles/global.scss';
import CookieConsenter from './src/util/cookietools';

const consenter = CookieConsenter();
let isUsLocale = false;

export const onClientEntry = () => {
  // Uncomment to enable geo-based cookie tracking for non-US visitors:
  // geolocate();
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  const newPath = location.pathname;
  const oldPath = prevLocation ? prevLocation.pathname : null;
  if (newPath !== oldPath) {
    const pagePath = location
      ? location.pathname + location.search + location.hash
      : null;
    setTimeout(() => consenter.trackScripts(isUsLocale, pagePath), 32);
  }
};

function geolocate() {
  fetch('/geo')
    .then((res) => res.json())
    .then((results) => {
      isUsLocale = results.country.code === 'US';
    })
    .catch((error) => {
      console.warn('Unable to determine country via /geo:', error.message);
    });
}
